import React from 'react'

import { useHideOn } from '../../utils/contexts/ResponsiveProvider'

const ResponsiveRender = ({ Sm, Default, ...props }) => {
  if (useHideOn('sm') && Sm) return <Sm {...props} />
  return <Default {...props} />
}

export default ResponsiveRender
